export const DEFAULT_UI_LANGUAGE = 'EN';
export const UI_LANGUAGE_OPTIONS = ['EN', 'DE', 'FR', 'ES', 'KR'];

const GLOBAL_LANGUAGE_KEY = 'jmg-ui-language';

export const normalizeUiLanguage = (value) => {
  const raw = String(value || '').trim().toUpperCase();
  if (raw === 'KO') return 'KR';
  if (UI_LANGUAGE_OPTIONS.includes(raw)) return raw;
  if (raw.startsWith('EN')) return 'EN';
  if (raw.startsWith('DE')) return 'DE';
  if (raw.startsWith('FR')) return 'FR';
  if (raw.startsWith('ES')) return 'ES';
  if (raw.startsWith('KR') || raw.startsWith('KO')) return 'KR';
  return DEFAULT_UI_LANGUAGE;
};

export const uiLanguageStorageKey = (uid) => `jmg-ui-language:${uid || 'anonymous'}`;

export const readUiLanguage = (uid) => {
  if (typeof window === 'undefined') return DEFAULT_UI_LANGUAGE;
  const userScoped = localStorage.getItem(uiLanguageStorageKey(uid));
  if (userScoped) return normalizeUiLanguage(userScoped);
  const global = localStorage.getItem(GLOBAL_LANGUAGE_KEY);
  if (global) return normalizeUiLanguage(global);
  return DEFAULT_UI_LANGUAGE;
};

export const writeUiLanguage = (uid, language) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeUiLanguage(language);
  localStorage.setItem(uiLanguageStorageKey(uid), normalized);
  localStorage.setItem(GLOBAL_LANGUAGE_KEY, normalized);
  window.dispatchEvent(
    new CustomEvent('jmg-ui-language-changed', {
      detail: { uid: uid || null, language: normalized },
    })
  );
};
